import Button from "src/components/Button";
import Modal from "src/components/Modal/Modal";
import useLoader from "src/hooks/useLoader";
import { passInterview } from "src/network/interview";
import { JobInterview } from "src/types";

interface IShortlistModal {
  interview: JobInterview;
  onShortlist: (i: JobInterview) => void;
  open: boolean;
  setOpen: (b: boolean) => void;
}

const ShortlistModal = ({ interview, open, setOpen, onShortlist }: IShortlistModal) => {
  const { id } = interview;
  const pass = async () => {
    const intv = await passInterview(id);
    await onShortlist(intv);
    setOpen(false);
  };
  const { ldng: _pass, loading: _passing } = useLoader(pass, {
    errorMsg: "Error shortlisting candidate",
    successMsg: "Candidate was shortlisted"
  });
  return (
    <Modal open={open} onChange={setOpen} className="!w-[500px] text-center">
      <p className="font-poppins text-lg font-semibold mt-6">
        Are you sure you want to shortlist this candidate to the next step?
      </p>
      <p className="mt-6 text-base font-medium text-inactive-gray">
        Candidates shortlisted by the recruiter as eligible will be moved to the 'Shortlisted' tab
      </p>

      <div className="flex items-center justify-center w-full mt-6 gap-6">
        <Button
          className="!w-fit !px-6 !h-[56px] !py-4 !rounded-3xl"
          onClick={() => setOpen(false)}
          variant="white_blue"
        >
          Cancel
        </Button>
        <Button
          className="!w-fit !px-6 !h-[56px]  !py-4 !rounded-3xl"
          onClick={_pass}
          loading={_passing}
        >
          Move to Shorlisted
        </Button>
      </div>
    </Modal>
  );
};

export default ShortlistModal;
